var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.998H2V4.99805H18M18 2.99805H10L8 0.998047H2C0.89 0.998047 0 1.88805 0 2.99805V14.998C0 15.5285 0.210714 16.0372 0.585786 16.4123C0.960859 16.7873 1.46957 16.998 2 16.998H18C18.5304 16.998 19.0391 16.7873 19.4142 16.4123C19.7893 16.0372 20 15.5285 20 14.998V4.99805C20 3.88805 19.1 2.99805 18 2.99805Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.c6fcd7fd1de14c4f38f548c11624a9e7.svg";
export { ForwardRef as ReactComponent };